(() => {
  'use strict';
  if (window.buceContactOptions) return;
  window.buceContactOptions = true;
  let frame = 0;
  const labels = {mila: 'Mila', whatsapp: 'WhatsApp'};
  function update() {
    frame = 0;
    const root = document.getElementById('cbw-chat-root');
    const fab = document.getElementById('cbw-fab');
    let wa = document.getElementById('buce-wa-direct');
    if (!wa) {
      wa = document.createElement('button');
      wa.type = 'button';
      wa.id = 'buce-wa-direct';
      wa.addEventListener('click', () => window.open('https://wa.me/573216681374?text=' + encodeURIComponent('Hola, Bucéfalo. ¿Me ayudas con mi compra?'), '_blank', 'noopener,noreferrer'));
      wa.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"24\" height=\"24\" fill=\"currentColor\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M20.52 3.48A11.83 11.83 0 0 0 12.04 0C5.45 0 .09 5.36.09 11.95c0 2.11.55 4.17 1.6 5.99L0 24l6.23-1.63a11.94 11.94 0 0 0 5.8 1.48h.01c6.59 0 11.95-5.36 11.96-11.95a11.87 11.87 0 0 0-3.48-8.42ZM12.04 21.83a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.7.97.99-3.61-.23-.37a9.88 9.88 0 0 1-1.51-5.28c0-5.48 4.46-9.94 9.95-9.94a9.88 9.88 0 0 1 7.03 2.92 9.88 9.88 0 0 1 2.91 7.04c0 5.48-4.46 9.94-9.94 9.94Zm5.45-7.44c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.77-1.65-2.07-.17-.3-.02-.46.13-.61.14-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35Z\"/></svg>";
      wa.title = 'Hablar por WhatsApp';
      document.body.appendChild(wa);
      document.body.classList.add('buce-contact-ready');
    }
    const container = wa;
    if (wa && wa.dataset.contactLabel !== labels.whatsapp) {
      wa.dataset.contactLabel = labels.whatsapp;
      wa.setAttribute('aria-label', 'Hablar por WhatsApp');
    }
    if (fab && fab.dataset.contactLabel !== labels.mila) {
      fab.dataset.contactLabel = labels.mila;
      fab.setAttribute('aria-label', 'Hablar con Mila, asesora virtual');
      fab.title = 'Hablar con Mila';
    }
    if (!container || !wa) return;
    const panel = document.getElementById('cbw-panel');
    const opened = Boolean(panel && panel.classList.contains('open'));
    if (opened && !panel.querySelector('.buce-contact-wa-inline')) {
      const link = document.createElement('a');
      link.className = 'buce-contact-wa-inline';
      link.textContent = 'Prefiero hablar por WhatsApp';
      link.href = 'https://wa.me/573216681374?text=' + encodeURIComponent('Hola, Bucéfalo. ¿Me ayudas con mi compra?');
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      const form = document.getElementById('cbw-form');
      if (form && form.parentNode === panel) panel.insertBefore(link, form);
      else panel.appendChild(link);
    }
    if (container.style.visibility !== (opened ? 'hidden' : 'visible')) {
      container.style.visibility = opened ? 'hidden' : 'visible';
    }
    if (opened) {
      if (root) ['right','bottom','left'].forEach(key => { if(root.style.getPropertyPriority(key)==='important') root.style.removeProperty(key); });
      return;
    }
    const hasMila = Boolean(root && fab && fab.getBoundingClientRect().width);
    const right = 16;
    const groupHeight = hasMila ? 96 : 44;
    let baseBottom = 24;
    const blockers = Array.from(document.querySelectorAll('button, a, [role="button"], .buce-v10-sticky, .t4s-toolbar')).filter(el => {
      if (el.closest('#cbw-chat-root, #carthike-chat-button-container')) return false;
      if (!el.getClientRects().length || getComputedStyle(el).visibility === 'hidden') return false;
      return el.matches('.buce-v10-sticky,.t4s-toolbar,button[name="checkout"],a[href="/checkout"],.t4s-btn__checkout') || /ir a pagar|pagar ahora|finalizar compra|continuar compra|agregar al carrito|comprar ahora|elige tu talla|escoge una opci|filtrar|show filters|abrir barra lateral|ver carrito/i.test((el.textContent || '') + ' ' + (el.getAttribute('aria-label') || ''));
    }).map(el => el.getBoundingClientRect()).filter(r => r.width && r.height && r.top < window.innerHeight && r.bottom > 0 && r.right > window.innerWidth - 72);
    for (let pass = 0; pass < blockers.length + 1; pass++) {
      const top = window.innerHeight - baseBottom - groupHeight;
      const bottomEdge = window.innerHeight - baseBottom;
      const collision = blockers.find(r => r.top < bottomEdge + 8 && r.bottom > top - 8);
      if (!collision) break;
      baseBottom = window.innerHeight - collision.top + 12;
    }
    baseBottom = Math.min(baseBottom, Math.max(24, window.innerHeight - groupHeight - 100));
    if (hasMila) {
      for (const [key,value] of Object.entries({right: right+'px', bottom: baseBottom+'px', left:'auto'})) {
        if(root.style.getPropertyValue(key)!==value) root.style.setProperty(key,value,'important');
      }
    }
    const bottom = baseBottom + (hasMila ? 52 : 0);
    for (const [key, value] of Object.entries({right: right+'px', bottom: bottom+'px', left: 'auto', top: 'auto'})) {
      if (container.style.getPropertyValue(key) !== value) container.style.setProperty(key, value, 'important');
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class','style','aria-hidden','hidden']});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('scroll', schedule, {passive: true, capture: true});
  document.addEventListener('transitionend', schedule, {passive: true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive: true});
  schedule();
})();

